import { IconSuccess16, Image, InlineText1, InlineText2, useDeviceType } from '@cian/ui-kit';
import { numberToPrettyString } from '@cian/utils';

import { clsx } from 'clsx';
import { FC } from 'react';

import { EBookCoworkingFormFields } from 'shared/components/BookCoworkingFrom/constants';
import { BookCoworkingModal } from 'shared/components/BookCoworkingModal';
import { ButtonWithAnalyticEvent } from 'shared/containers/ButtonWithAnalyticEvent';
import {
  ITrackBookingButtonClick,
  trackBookingButtonClick,
} from 'shared/store/analytics/actions/trackBookingButtonClick';
import { EObjectType } from 'shared/utils/formatters/getCustomUrl';

import { TFlexOfficeProps } from './types';

import * as styles from './styles.css';

export const FlexOffice: FC<TFlexOfficeProps> = props => {
  const {
    className,
    photos,
    area,
    workplaceCount,
    id,
    priceForWorkplace,
    priceAllPerMonth,
    selectedOfferId,
    fullUrl,
    trackClickToOffer,
  } = props;
  const [photo] = photos;

  const deviceType = useDeviceType();

  const Text = deviceType === 'desktop' ? InlineText1 : InlineText2;
  const trackingParams: ITrackBookingButtonClick = { offerId: id, gaObjectType: EObjectType.FLEX_OFFICE };

  return (
    <div className={clsx(styles['root'], className)}>
      <div className={styles['overlay']} />
      <div className={styles['border']}>
        <a className={styles['link']} href={fullUrl} rel="noreferrer" target="_blank" onClick={trackClickToOffer}>
          {photo && (
            <div className={styles['image']} data-testid="flex-office-images">
              <Image alt={`flex_office_${id}`} height={56} src={photo.mini} width={56} />
            </div>
          )}
          <span className={styles['title']}>
            <Text color="primary_100" fontWeight="bold">
              {`Отдельный офис\u00A0${area}\u00A0м² на\u00A0${workplaceCount}\u00A0чел.`}
            </Text>
            {id === selectedOfferId && (
              <span className={styles['selected-item']} data-testid="flex-office-icon-success">
                <IconSuccess16 color="primary_100" />
              </span>
            )}
          </span>
        </a>
        <div className={styles['prices']}>
          <div className={styles['price-list']}>
            <InlineText2>{`${numberToPrettyString(priceForWorkplace)} ₽/мес. за\u00A0рабочее место`}</InlineText2>
            <InlineText2 color="gray60_100">
              {`${numberToPrettyString(priceAllPerMonth)} ₽/мес. за\u00A0весь офис`}
            </InlineText2>
          </div>
        </div>
        <BookCoworkingModal
          analyticParams={{ offerId: id }}
          formInitialState={{
            [EBookCoworkingFormFields.WorkplaceCount]: {
              errorMessage: null,
              value: `${workplaceCount}`,
            },
          }}
        >
          {modalVisibilityState => (
            <div className={styles['button']}>
              <ButtonWithAnalyticEvent
                analyticsParams={trackingParams}
                size="XS"
                theme="stroke_secondary"
                trackAnalyticEvent={trackBookingButtonClick}
                type="button"
                onClick={modalVisibilityState.setTrue}
              >
                Забронировать
              </ButtonWithAnalyticEvent>
            </div>
          )}
        </BookCoworkingModal>
      </div>
    </div>
  );
};

FlexOffice.displayName = 'FlexOffice';
